import { onlineSource, RefetchEventManager, windowFocusSource } from '@apollo/client';

export const createReportRefetchEventManager = () =>
  new RefetchEventManager({
    sources: { online: onlineSource, windowFocus: windowFocusSource },
  });
